import { FiCheck } from "react-icons/fi";

const EditorPopup = ({
  heading,
  children,
  onExit,
  activeOn,
  popupMenu,
  pos,
  items,
  styleHandler,
  nodes,
  onMouseDown,
}) => {
  const onClick = (command, value) => {
    if (value) {
      styleHandler(command, value);
    } else {
      styleHandler(command);
    }
  };

  // const onMouseDown = () => {
  //   console.log("M");
  // };
  return (
    <div
      style={{
        left: pos.left,
        top: pos.top < 200 ? pos.top + 100 : popupMenu === activeOn ? pos.top - 70 : pos.top,
      }}
      // onMouseDown={onMouseDown}
      className={`fixed left-0 z-[200] shadow-lg rounded bg-white transition-all w-auto transform -translate-y-1/2 -translate-x-1/2 ${
        popupMenu === activeOn
          ? "opacity-100 visible pointer-events-auto"
          : "opacity-0 invisible pointer-events-none"
      }`}
    >
      <div className="border-b border-solid border-slate-300 h-8 flex items-center justify-between overflow-hidden w-auto rounded-t">
        <div className="text-sm font-semibold text-zinc-800 px-8 text-center flex-1 pointer-events-none">
          {heading}
        </div>
        <div
          onClick={onExit}
          onMouseDown={onMouseDown}
          className="bg-sky-500 h-full w-8 flex items-center justify-center cursor-pointer"
        >
          <FiCheck color="#fff" />
        </div>
      </div>
      {items?.length > 0 && (
        <div className="p-3 ">
          <div className="flex items-center justify-between text-sm font-semibold w-60 px-4">
            {items.map((it, i) => (
              <button
                key={i}
                onClick={() => onClick(it.command, it.value)}
                className={`cursor-pointer  ${
                  nodes.includes(it.node) ? "text-blue-600" : "text-zinc-700"
                }`}
              >
                {it.content}
              </button>
            ))}
          </div>
        </div>
      )}
      <div className="p-3">{children}</div>
    </div>
  );
};

export default EditorPopup;
